import _objectWithoutProperties from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["options", "deal_supplier"],
  _excluded2 = ["options", "name"];
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
// 投标供应商行默认结构（首行传优联服务）；options 仅本地下拉回显用，提交前剔除
export var createBiddingSupplierRow = function createBiddingSupplierRow() {
  var companyName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    company_name: companyName,
    customer_id: '',
    price: '',
    is_win: false,
    options: []
  };
};

// 优联服务固定作为首位参标供应商，后端约定其客户 id 为 296
export var createUnitedServiceSupplier = function createUnitedServiceSupplier() {
  return _objectSpread(_objectSpread({}, createBiddingSupplierRow('优联服务')), {}, {
    customer_id: '296'
  });
};

// 三个任务块的默认结构（初始表单与取消勾选重置共用，避免多处重复定义漂移）
export var createTaskItemDefaults = function createTaskItemDefaults() {
  return {
    mall_decoration: {
      scene: '',
      // 使用场景：1-下单使用 2-演示使用
      delivery_time: '',
      // 装修交付时间(yyyy-MM-dd)
      budget: '',
      mall_name: '',
      banner: '',
      // 客户Banner：1-更换 2-不更换
      modules: [],
      // 装修功能板块：1-电影 2-生日 3-礼包 4-商城 5-其他
      package_id: '',
      // 礼包方案ID（模块含"礼包"时必填）
      // 商品是否有折扣/商城商品折扣 字段已注释（需求下线，如需恢复取消注释）
      // has_discount: '', // 商品是否有折扣：1-否 2-是（模块含"商城"时必填）
      // discount: '', // 商城商品折扣（有折扣时必填）
      remark: '',
      person_charge_id: '',
      // 装修负责人（审批时必填）
      person_charge_name: ''
    },
    bidding_support: {
      person_charge_id: null,
      person_charge_name: '',
      status: '',
      bid_files: [],
      is_check: '',
      // 是否检查：1-是 2-否
      check_person_id: null,
      check_person_name: '',
      task_status: '',
      // 开标结果：450已开标未出结果 500未中标 550已中标
      delivery_status: '',
      // 交付结果：550未交付 600已交付（开标结果=已中标时展示）
      reason: '',
      // 优联未中标原因：1被废标 2未中标 3流标
      supplier: [createUnitedServiceSupplier()],
      // 供应商参标情况：首行优联服务不可修改
      announcement: [],
      bid_opening_remarks: '',
      delivery_remarks: ''
    },
    card_and_coupon_design: {
      order_business_type: '',
      card_type: '',
      order_gift_id_type: '',
      // 创建订单/礼包ID：1-已创建订单 2-已创建礼包ID 3-未创建订单或礼包ID
      order_number: '',
      gift_id: '',
      estimated_amount: '',
      design_product_type: '',
      add_magnetic_stripe: '',
      // 卡增加磁条：1-是 2-否
      card_size: '',
      // 卡尺寸：1-标版 2-特殊
      card_size_custom: '',
      coupon_size: '',
      // 券尺寸：1-标版 2-特殊
      coupon_size_custom: '',
      gift_coupon_type: '',
      // 礼包券类型：1-单页 2-双折页 3-三折页 4-四折页 5-特殊要求
      gift_coupon_size: '',
      // 礼包券尺寸：1-标版 2-特殊
      gift_coupon_size_custom: '',
      gift_coupon_special_requirement: '',
      need_card_coupon_sleeve: '',
      // 是否需要卡券套：1-需要 2-不需要
      card_coupon_sleeve_size: '',
      // 卡券套尺寸：1-卡套10*6cm 2-特殊 3-券套13.5*7cm(提货券不展示) 4-提货券券套18.5*10cm(提货券/券套)
      card_coupon_sleeve_size_custom: '',
      expedited_not: '',
      // 是否加急设计：1-正常时效 2-加急
      need_printing: '',
      // 是否需要印刷：1-需要 2-不需要
      printing_quantity: '',
      urgent_printing: '',
      // 是否加急印刷：1-正常时效 2-加急
      design_complexity: 0,
      // 设计复杂度：1-简单 2-中级 3-复杂
      customer_logo: [],
      refer_style: [],
      customer_demand: '',
      person_charge_id: '',
      // 设计负责人（审批时必填）
      person_charge_name: ''
    },
    quotation: {
      business_type: '',
      // 业务类型
      card_type: '',
      // 卡类型
      money: '',
      // 采购金额（大于等于0，最多两位小数）
      number: '',
      // 人数（大于0正整数）
      budget: '',
      // 单人预算（money ÷ number 联动）
      payment_method: '',
      // 结算方式：1-按售卡结算 2-按消费结算
      description: '',
      // 功能菜单描述：1-通用卡规则 2-个性化卡规则
      order_rules: '',
      // 备注（常显，选填）
      final_quotation: '',
      // 最终报价折扣（0-1之间，最多三位小数）
      cost: '',
      // 服务费成本（8位以内数字，最多两位小数）
      time_limit: '',
      // 报价单时效（失效日期，默认总经理审批时间+30天）
      accounting_method: '',
      // 佣金核算方式：1-系统核算 2-人工核算
      commission: '',
      // 佣金（0-100，最多两位小数）
      performance: '',
      // 计入业绩（0-500，最多两位小数）
      manager_remarks: '',
      // 总经理备注（总经理审批后展示）
      vp_remarks: '' // VP备注（VP审批后展示）
    }
  };
};

// 历史成交供应商行默认结构；options 仅本地下拉回显用，提交前剔除
export var createOtherSupplierRow = function createOtherSupplierRow() {
  return {
    deal_date: '',
    company_name: '',
    customer_id: '',
    deal_discount: '',
    delivery_form: '',
    delivery_pain_point: '',
    options: []
  };
};

// 后端用 '0' 表示未匹配到客户，与空值一并按未匹配处理
export var normalizeCustomerId = function normalizeCustomerId(value) {
  return value === undefined || value === null || value === '' || String(value) === '0' ? '' : String(value);
};

// 成交供应商提交时只回传 company_name/customer_id，旧字段与本地下拉选项不外发
export var normalizeOtherSuppliers = function normalizeOtherSuppliers(list) {
  return (Array.isArray(list) ? list : []).map(function (item) {
    var options = item.options,
      deal_supplier = item.deal_supplier,
      supplier = _objectWithoutProperties(item, _excluded);
    return _objectSpread(_objectSpread({}, supplier), {}, {
      company_name: supplier.company_name || '',
      customer_id: normalizeCustomerId(supplier.customer_id)
    });
  });
};

// 投标供应商提交时把 name 拆分为 company_name/customer_id，is_win 转字符串，本地选项不外发
export var normalizeBiddingSuppliers = function normalizeBiddingSuppliers(list) {
  return (Array.isArray(list) ? list : []).map(function (item) {
    var options = item.options,
      name = item.name,
      supplier = _objectWithoutProperties(item, _excluded2);
    return _objectSpread(_objectSpread({}, supplier), {}, {
      company_name: supplier.company_name || name || '',
      customer_id: normalizeCustomerId(supplier.customer_id),
      is_win: String(supplier.is_win) === '1' || supplier.is_win === true ? '1' : '0'
    });
  });
};